import axios from 'axios';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Global variable to store the Redux store reference
let storeInstance = null;

// Function to set the store instance
export const setStoreInstance = (store) => {
  storeInstance = store;
};

// Function to get current account ID from store
const getCurrentAccountId = () => {
  if (!storeInstance) {
    console.warn('Store instance not available for X-TenantId header');
    return null;
  }
  
  const state = storeInstance.getState();
  const account = state.app.account;
  
  return account?.id || null;
};

const setupAxiosInterceptors = (signinRedirect, store) => {
  // Set the store instance for use in interceptors
  setStoreInstance(store);

  // Request interceptor to add X-TenantId header
  axiosInstance.interceptors.request.use(
    (config) => {
      // Let the browser set multipart boundaries for FormData uploads.
      if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
        delete config.headers['Content-Type'];
      }

      const accountId = getCurrentAccountId();
      
      if (accountId) {
        config.headers['X-TenantId'] = accountId;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor (existing)
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if 401 Unauthorized
        signinRedirect();
      }
      return Promise.reject(error);
    }
  );
};

export { axiosInstance, setupAxiosInterceptors };